var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.label)?_c('span',{staticClass:"br-status-badge",class:`br-status-badge--${_vm.variant}`},[(_vm.iconUrl)?_c('img',{staticClass:"br-status-badge__icon",attrs:{"src":_vm.iconUrl,"width":"12","height":"12","alt":""}}):_vm._e(),_c('span',{staticClass:"br-status-badge__text"},[_vm._v(_vm._s(_vm.label))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }